/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LandMonitoringRouteImport } from './routes/land-monitoring'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardApiDocsRouteImport } from './routes/dashboard/api-docs'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardTasksIndexRouteImport } from './routes/dashboard/tasks/index'
import { Route as DashboardReviewsIndexRouteImport } from './routes/dashboard/reviews/index'
import { Route as DashboardLandMonitoringIndexRouteImport } from './routes/dashboard/land-monitoring/index'
import { Route as DashboardFeedbackIndexRouteImport } from './routes/dashboard/feedback/index'
import { Route as DashboardAuditIndexRouteImport } from './routes/dashboard/audit/index'
import { Route as DashboardTaskTaskIdRouteImport } from './routes/dashboard/task/$taskId'
import { Route as DashboardLandMonitoringAddPropertyRouteImport } from './routes/dashboard/land-monitoring/add-property'
import { Route as DashboardInspectionInspectionIdRouteImport } from './routes/dashboard/inspection/$inspectionId'
import { Route as DashboardTaskTaskIdIndexRouteImport } from './routes/dashboard/task/$taskId/index'
import { Route as DashboardLandMonitoringPropertyIdIndexRouteImport } from './routes/dashboard/land-monitoring/$propertyId/index'
import { Route as DashboardInspectionInspectionIdIndexRouteImport } from './routes/dashboard/inspection/$inspectionId/index'
import { Route as DashboardTaskTaskIdReportRouteImport } from './routes/dashboard/task/$taskId/report'
import { Route as DashboardLandMonitoringPropertyIdReportIdRouteImport } from './routes/dashboard/land-monitoring/$propertyId/$reportId'

const DashboardRegionsIndexLazyRouteImport = createFileRoute(
  '/dashboard/regions/',
)()
const DashboardRegionsNewLazyRouteImport = createFileRoute(
  '/dashboard/regions/new',
)()
const DashboardRegionsRegionIdEditLazyRouteImport = createFileRoute(
  '/dashboard/regions/$regionId/edit',
)()

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LandMonitoringRoute = LandMonitoringRouteImport.update({
  id: '/land-monitoring',
  path: '/land-monitoring',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardApiDocsRoute = DashboardApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/api-docs.lazy').then((d) => d.Route),
)
const DashboardRegionsIndexLazyRoute =
  DashboardRegionsIndexLazyRouteImport.update({
    id: '/regions/',
    path: '/regions/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/regions/index.lazy').then((d) => d.Route),
  )
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTasksIndexRoute = DashboardTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReviewsIndexRoute = DashboardReviewsIndexRouteImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLandMonitoringIndexRoute =
  DashboardLandMonitoringIndexRouteImport.update({
    id: '/land-monitoring/',
    path: '/land-monitoring/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFeedbackIndexRoute = DashboardFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuditIndexRoute = DashboardAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRegionsNewLazyRoute = DashboardRegionsNewLazyRouteImport.update({
  id: '/regions/new',
  path: '/regions/new',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/regions/new.lazy').then((d) => d.Route),
)
const DashboardTaskTaskIdRoute = DashboardTaskTaskIdRouteImport.update({
  id: '/task/$taskId',
  path: '/task/$taskId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLandMonitoringAddPropertyRoute =
  DashboardLandMonitoringAddPropertyRouteImport.update({
    id: '/land-monitoring/add-property',
    path: '/land-monitoring/add-property',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/land-monitoring/add-property.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardInspectionInspectionIdRoute =
  DashboardInspectionInspectionIdRouteImport.update({
    id: '/inspection/$inspectionId',
    path: '/inspection/$inspectionId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardTaskTaskIdIndexRoute =
  DashboardTaskTaskIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardTaskTaskIdRoute,
  } as any)
const DashboardLandMonitoringPropertyIdIndexRoute =
  DashboardLandMonitoringPropertyIdIndexRouteImport.update({
    id: '/land-monitoring/$propertyId/',
    path: '/land-monitoring/$propertyId/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/land-monitoring/$propertyId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardInspectionInspectionIdIndexRoute =
  DashboardInspectionInspectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInspectionInspectionIdRoute,
  } as any)
const DashboardRegionsRegionIdEditLazyRoute =
  DashboardRegionsRegionIdEditLazyRouteImport.update({
    id: '/regions/$regionId/edit',
    path: '/regions/$regionId/edit',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/regions/$regionId.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardTaskTaskIdReportRoute =
  DashboardTaskTaskIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => DashboardTaskTaskIdRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/task/$taskId/report.lazy').then((d) => d.Route),
  )
const DashboardLandMonitoringPropertyIdReportIdRoute =
  DashboardLandMonitoringPropertyIdReportIdRouteImport.update({
    id: '/land-monitoring/$propertyId/$reportId',
    path: '/land-monitoring/$propertyId/$reportId',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact-us': typeof ContactUsRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/land-monitoring': typeof LandMonitoringRoute
  '/login': typeof LoginRoute
  '/dashboard/api-docs': typeof DashboardApiDocsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/inspection/$inspectionId': typeof DashboardInspectionInspectionIdRouteWithChildren
  '/dashboard/land-monitoring/add-property': typeof DashboardLandMonitoringAddPropertyRoute
  '/dashboard/task/$taskId': typeof DashboardTaskTaskIdRouteWithChildren
  '/dashboard/regions/new': typeof DashboardRegionsNewLazyRoute
  '/dashboard/audit/': typeof DashboardAuditIndexRoute
  '/dashboard/feedback/': typeof DashboardFeedbackIndexRoute
  '/dashboard/land-monitoring/': typeof DashboardLandMonitoringIndexRoute
  '/dashboard/reviews/': typeof DashboardReviewsIndexRoute
  '/dashboard/tasks/': typeof DashboardTasksIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/regions/': typeof DashboardRegionsIndexLazyRoute
  '/dashboard/land-monitoring/$propertyId/$reportId': typeof DashboardLandMonitoringPropertyIdReportIdRoute
  '/dashboard/task/$taskId/report': typeof DashboardTaskTaskIdReportRoute
  '/dashboard/regions/$regionId/edit': typeof DashboardRegionsRegionIdEditLazyRoute
  '/dashboard/inspection/$inspectionId/': typeof DashboardInspectionInspectionIdIndexRoute
  '/dashboard/land-monitoring/$propertyId/': typeof DashboardLandMonitoringPropertyIdIndexRoute
  '/dashboard/task/$taskId/': typeof DashboardTaskTaskIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact-us': typeof ContactUsRoute
  '/land-monitoring': typeof LandMonitoringRoute
  '/login': typeof LoginRoute
  '/dashboard/api-docs': typeof DashboardApiDocsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/land-monitoring/add-property': typeof DashboardLandMonitoringAddPropertyRoute
  '/dashboard/regions/new': typeof DashboardRegionsNewLazyRoute
  '/dashboard/audit': typeof DashboardAuditIndexRoute
  '/dashboard/feedback': typeof DashboardFeedbackIndexRoute
  '/dashboard/land-monitoring': typeof DashboardLandMonitoringIndexRoute
  '/dashboard/reviews': typeof DashboardReviewsIndexRoute
  '/dashboard/tasks': typeof DashboardTasksIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/regions': typeof DashboardRegionsIndexLazyRoute
  '/dashboard/land-monitoring/$propertyId/$reportId': typeof DashboardLandMonitoringPropertyIdReportIdRoute
  '/dashboard/task/$taskId/report': typeof DashboardTaskTaskIdReportRoute
  '/dashboard/regions/$regionId/edit': typeof DashboardRegionsRegionIdEditLazyRoute
  '/dashboard/inspection/$inspectionId': typeof DashboardInspectionInspectionIdIndexRoute
  '/dashboard/land-monitoring/$propertyId': typeof DashboardLandMonitoringPropertyIdIndexRoute
  '/dashboard/task/$taskId': typeof DashboardTaskTaskIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact-us': typeof ContactUsRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/land-monitoring': typeof LandMonitoringRoute
  '/login': typeof LoginRoute
  '/dashboard/api-docs': typeof DashboardApiDocsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/inspection/$inspectionId': typeof DashboardInspectionInspectionIdRouteWithChildren
  '/dashboard/land-monitoring/add-property': typeof DashboardLandMonitoringAddPropertyRoute
  '/dashboard/task/$taskId': typeof DashboardTaskTaskIdRouteWithChildren
  '/dashboard/regions/new': typeof DashboardRegionsNewLazyRoute
  '/dashboard/audit/': typeof DashboardAuditIndexRoute
  '/dashboard/feedback/': typeof DashboardFeedbackIndexRoute
  '/dashboard/land-monitoring/': typeof DashboardLandMonitoringIndexRoute
  '/dashboard/reviews/': typeof DashboardReviewsIndexRoute
  '/dashboard/tasks/': typeof DashboardTasksIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/regions/': typeof DashboardRegionsIndexLazyRoute
  '/dashboard/land-monitoring/$propertyId/$reportId': typeof DashboardLandMonitoringPropertyIdReportIdRoute
  '/dashboard/task/$taskId/report': typeof DashboardTaskTaskIdReportRoute
  '/dashboard/regions/$regionId/edit': typeof DashboardRegionsRegionIdEditLazyRoute
  '/dashboard/inspection/$inspectionId/': typeof DashboardInspectionInspectionIdIndexRoute
  '/dashboard/land-monitoring/$propertyId/': typeof DashboardLandMonitoringPropertyIdIndexRoute
  '/dashboard/task/$taskId/': typeof DashboardTaskTaskIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact-us'
    | '/dashboard'
    | '/land-monitoring'
    | '/login'
    | '/dashboard/api-docs'
    | '/dashboard/'
    | '/dashboard/inspection/$inspectionId'
    | '/dashboard/land-monitoring/add-property'
    | '/dashboard/task/$taskId'
    | '/dashboard/regions/new'
    | '/dashboard/audit/'
    | '/dashboard/feedback/'
    | '/dashboard/land-monitoring/'
    | '/dashboard/reviews/'
    | '/dashboard/tasks/'
    | '/dashboard/users/'
    | '/dashboard/regions/'
    | '/dashboard/land-monitoring/$propertyId/$reportId'
    | '/dashboard/task/$taskId/report'
    | '/dashboard/regions/$regionId/edit'
    | '/dashboard/inspection/$inspectionId/'
    | '/dashboard/land-monitoring/$propertyId/'
    | '/dashboard/task/$taskId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact-us'
    | '/land-monitoring'
    | '/login'
    | '/dashboard/api-docs'
    | '/dashboard'
    | '/dashboard/land-monitoring/add-property'
    | '/dashboard/regions/new'
    | '/dashboard/audit'
    | '/dashboard/feedback'
    | '/dashboard/land-monitoring'
    | '/dashboard/reviews'
    | '/dashboard/tasks'
    | '/dashboard/users'
    | '/dashboard/regions'
    | '/dashboard/land-monitoring/$propertyId/$reportId'
    | '/dashboard/task/$taskId/report'
    | '/dashboard/regions/$regionId/edit'
    | '/dashboard/inspection/$inspectionId'
    | '/dashboard/land-monitoring/$propertyId'
    | '/dashboard/task/$taskId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact-us'
    | '/dashboard'
    | '/land-monitoring'
    | '/login'
    | '/dashboard/api-docs'
    | '/dashboard/'
    | '/dashboard/inspection/$inspectionId'
    | '/dashboard/land-monitoring/add-property'
    | '/dashboard/task/$taskId'
    | '/dashboard/regions/new'
    | '/dashboard/audit/'
    | '/dashboard/feedback/'
    | '/dashboard/land-monitoring/'
    | '/dashboard/reviews/'
    | '/dashboard/tasks/'
    | '/dashboard/users/'
    | '/dashboard/regions/'
    | '/dashboard/land-monitoring/$propertyId/$reportId'
    | '/dashboard/task/$taskId/report'
    | '/dashboard/regions/$regionId/edit'
    | '/dashboard/inspection/$inspectionId/'
    | '/dashboard/land-monitoring/$propertyId/'
    | '/dashboard/task/$taskId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ContactUsRoute: typeof ContactUsRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LandMonitoringRoute: typeof LandMonitoringRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/land-monitoring': {
      id: '/land-monitoring'
      path: '/land-monitoring'
      fullPath: '/land-monitoring'
      preLoaderRoute: typeof LandMonitoringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/api-docs': {
      id: '/dashboard/api-docs'
      path: '/api-docs'
      fullPath: '/dashboard/api-docs'
      preLoaderRoute: typeof DashboardApiDocsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/regions/': {
      id: '/dashboard/regions/'
      path: '/regions'
      fullPath: '/dashboard/regions/'
      preLoaderRoute: typeof DashboardRegionsIndexLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users/'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tasks/': {
      id: '/dashboard/tasks/'
      path: '/tasks'
      fullPath: '/dashboard/tasks/'
      preLoaderRoute: typeof DashboardTasksIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reviews/': {
      id: '/dashboard/reviews/'
      path: '/reviews'
      fullPath: '/dashboard/reviews/'
      preLoaderRoute: typeof DashboardReviewsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/land-monitoring/': {
      id: '/dashboard/land-monitoring/'
      path: '/land-monitoring'
      fullPath: '/dashboard/land-monitoring/'
      preLoaderRoute: typeof DashboardLandMonitoringIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/feedback/': {
      id: '/dashboard/feedback/'
      path: '/feedback'
      fullPath: '/dashboard/feedback/'
      preLoaderRoute: typeof DashboardFeedbackIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/audit/': {
      id: '/dashboard/audit/'
      path: '/audit'
      fullPath: '/dashboard/audit/'
      preLoaderRoute: typeof DashboardAuditIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/regions/new': {
      id: '/dashboard/regions/new'
      path: '/regions/new'
      fullPath: '/dashboard/regions/new'
      preLoaderRoute: typeof DashboardRegionsNewLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/task/$taskId': {
      id: '/dashboard/task/$taskId'
      path: '/task/$taskId'
      fullPath: '/dashboard/task/$taskId'
      preLoaderRoute: typeof DashboardTaskTaskIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/land-monitoring/add-property': {
      id: '/dashboard/land-monitoring/add-property'
      path: '/land-monitoring/add-property'
      fullPath: '/dashboard/land-monitoring/add-property'
      preLoaderRoute: typeof DashboardLandMonitoringAddPropertyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/inspection/$inspectionId': {
      id: '/dashboard/inspection/$inspectionId'
      path: '/inspection/$inspectionId'
      fullPath: '/dashboard/inspection/$inspectionId'
      preLoaderRoute: typeof DashboardInspectionInspectionIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/task/$taskId/': {
      id: '/dashboard/task/$taskId/'
      path: '/'
      fullPath: '/dashboard/task/$taskId/'
      preLoaderRoute: typeof DashboardTaskTaskIdIndexRouteImport
      parentRoute: typeof DashboardTaskTaskIdRoute
    }
    '/dashboard/land-monitoring/$propertyId/': {
      id: '/dashboard/land-monitoring/$propertyId/'
      path: '/land-monitoring/$propertyId'
      fullPath: '/dashboard/land-monitoring/$propertyId/'
      preLoaderRoute: typeof DashboardLandMonitoringPropertyIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/inspection/$inspectionId/': {
      id: '/dashboard/inspection/$inspectionId/'
      path: '/'
      fullPath: '/dashboard/inspection/$inspectionId/'
      preLoaderRoute: typeof DashboardInspectionInspectionIdIndexRouteImport
      parentRoute: typeof DashboardInspectionInspectionIdRoute
    }
    '/dashboard/regions/$regionId/edit': {
      id: '/dashboard/regions/$regionId/edit'
      path: '/regions/$regionId/edit'
      fullPath: '/dashboard/regions/$regionId/edit'
      preLoaderRoute: typeof DashboardRegionsRegionIdEditLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/task/$taskId/report': {
      id: '/dashboard/task/$taskId/report'
      path: '/report'
      fullPath: '/dashboard/task/$taskId/report'
      preLoaderRoute: typeof DashboardTaskTaskIdReportRouteImport
      parentRoute: typeof DashboardTaskTaskIdRoute
    }
    '/dashboard/land-monitoring/$propertyId/$reportId': {
      id: '/dashboard/land-monitoring/$propertyId/$reportId'
      path: '/land-monitoring/$propertyId/$reportId'
      fullPath: '/dashboard/land-monitoring/$propertyId/$reportId'
      preLoaderRoute: typeof DashboardLandMonitoringPropertyIdReportIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardInspectionInspectionIdRouteChildren {
  DashboardInspectionInspectionIdIndexRoute: typeof DashboardInspectionInspectionIdIndexRoute
}

const DashboardInspectionInspectionIdRouteChildren: DashboardInspectionInspectionIdRouteChildren =
  {
    DashboardInspectionInspectionIdIndexRoute:
      DashboardInspectionInspectionIdIndexRoute,
  }

const DashboardInspectionInspectionIdRouteWithChildren =
  DashboardInspectionInspectionIdRoute._addFileChildren(
    DashboardInspectionInspectionIdRouteChildren,
  )

interface DashboardTaskTaskIdRouteChildren {
  DashboardTaskTaskIdReportRoute: typeof DashboardTaskTaskIdReportRoute
  DashboardTaskTaskIdIndexRoute: typeof DashboardTaskTaskIdIndexRoute
}

const DashboardTaskTaskIdRouteChildren: DashboardTaskTaskIdRouteChildren = {
  DashboardTaskTaskIdReportRoute: DashboardTaskTaskIdReportRoute,
  DashboardTaskTaskIdIndexRoute: DashboardTaskTaskIdIndexRoute,
}

const DashboardTaskTaskIdRouteWithChildren =
  DashboardTaskTaskIdRoute._addFileChildren(DashboardTaskTaskIdRouteChildren)

interface DashboardRouteChildren {
  DashboardApiDocsRoute: typeof DashboardApiDocsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardInspectionInspectionIdRoute: typeof DashboardInspectionInspectionIdRouteWithChildren
  DashboardLandMonitoringAddPropertyRoute: typeof DashboardLandMonitoringAddPropertyRoute
  DashboardTaskTaskIdRoute: typeof DashboardTaskTaskIdRouteWithChildren
  DashboardRegionsNewLazyRoute: typeof DashboardRegionsNewLazyRoute
  DashboardAuditIndexRoute: typeof DashboardAuditIndexRoute
  DashboardFeedbackIndexRoute: typeof DashboardFeedbackIndexRoute
  DashboardLandMonitoringIndexRoute: typeof DashboardLandMonitoringIndexRoute
  DashboardReviewsIndexRoute: typeof DashboardReviewsIndexRoute
  DashboardTasksIndexRoute: typeof DashboardTasksIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardRegionsIndexLazyRoute: typeof DashboardRegionsIndexLazyRoute
  DashboardLandMonitoringPropertyIdReportIdRoute: typeof DashboardLandMonitoringPropertyIdReportIdRoute
  DashboardRegionsRegionIdEditLazyRoute: typeof DashboardRegionsRegionIdEditLazyRoute
  DashboardLandMonitoringPropertyIdIndexRoute: typeof DashboardLandMonitoringPropertyIdIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardApiDocsRoute: DashboardApiDocsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardInspectionInspectionIdRoute:
    DashboardInspectionInspectionIdRouteWithChildren,
  DashboardLandMonitoringAddPropertyRoute:
    DashboardLandMonitoringAddPropertyRoute,
  DashboardTaskTaskIdRoute: DashboardTaskTaskIdRouteWithChildren,
  DashboardRegionsNewLazyRoute: DashboardRegionsNewLazyRoute,
  DashboardAuditIndexRoute: DashboardAuditIndexRoute,
  DashboardFeedbackIndexRoute: DashboardFeedbackIndexRoute,
  DashboardLandMonitoringIndexRoute: DashboardLandMonitoringIndexRoute,
  DashboardReviewsIndexRoute: DashboardReviewsIndexRoute,
  DashboardTasksIndexRoute: DashboardTasksIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardRegionsIndexLazyRoute: DashboardRegionsIndexLazyRoute,
  DashboardLandMonitoringPropertyIdReportIdRoute:
    DashboardLandMonitoringPropertyIdReportIdRoute,
  DashboardRegionsRegionIdEditLazyRoute: DashboardRegionsRegionIdEditLazyRoute,
  DashboardLandMonitoringPropertyIdIndexRoute:
    DashboardLandMonitoringPropertyIdIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactUsRoute: ContactUsRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LandMonitoringRoute: LandMonitoringRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
